import {Component, Inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SizeProfile} from "../../product-details/interface/size-profile";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {FormsModule} from "@angular/forms";

@Component({
	selector: 'fb-product-size-guide-dialog',
	standalone: true,
	imports: [CommonModule, MatSlideToggleModule, FormsModule],
	templateUrl: './product-size-guide-dialog.component.html',
	styleUrls: ['./product-size-guide-dialog.component.scss']
})
export class ProductSizeGuideDialogComponent {

	public newSizeArray: {
		label: string
		guideNumber: number[]
	}[] = [];
	public isCm: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<ProductSizeGuideDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { sizeProfile: SizeProfile, productGroup: "finished" | "fabric" | "swatch" }
	) {
		if(this.data.productGroup === 'finished') {
			const guideMap = new Map<string, number[]>();

			this.data.sizeProfile.sizeProfileGuideList.forEach(sizeGuide => {
				const numbers = guideMap.get(sizeGuide.guide) || [];
				numbers.push(sizeGuide.value);
				numbers.sort((a, b) => a - b);
				guideMap.set(sizeGuide.guide, numbers);
			});

			this.newSizeArray = Array.from(guideMap.entries())
				.map(([label, guideNumber]) => ({
					label,
					guideNumber
				}))

		}
	}
}
